import Dexie, { type EntityTable } from 'dexie';
import {
  type PermissionsSchema,
  permissionsSchema,
} from './schemas/permissions';
import {
  type RrwebChunksSchema,
  type RrwebEventsSchema,
  rrwebChunksSchema,
  rrwebEventsSchema,
} from './schemas/rrweb';
import {
  type TanstackQueriesSchema,
  tanstackQueriesSchema,
} from './schemas/tanstack-queries';
import { type UsersSchema, usersSchema } from './schemas/users';

const DB_NAME = 'HIS';
const DB_VERSION_1 = 1;
const DB_VERSION_2 = 2;
const DB_VERSION_3 = 3;

const db = new Dexie(DB_NAME) as Dexie & {
  tanstackQueries: EntityTable<TanstackQueriesSchema, 'key'>;
  users: EntityTable<UsersSchema, 'id'>;
  permissions: EntityTable<PermissionsSchema, 'id'>;
  rrwebEvents: EntityTable<RrwebEventsSchema, 'id'>;
  rrwebChunks: EntityTable<RrwebChunksSchema, 'id'>;
};

db.version(DB_VERSION_1).stores({
  tanstackQueries: tanstackQueriesSchema,
  users: usersSchema,
  permissions: permissionsSchema,
});

db.version(DB_VERSION_2).stores({
  tanstackQueries: tanstackQueriesSchema,
  users: usersSchema,
  permissions: permissionsSchema,
  rrwebEvents: rrwebEventsSchema,
  rrwebChunks: rrwebChunksSchema,
});

db.version(DB_VERSION_3).stores({
  tanstackQueries: tanstackQueriesSchema,
  users: usersSchema,
  permissions: permissionsSchema,
  rrwebEvents: rrwebEventsSchema,
  rrwebChunks: rrwebChunksSchema,
});

export const dbClear = () =>
  db.transaction('rw', db.tables, async () => {
    for (const table of db.tables) {
      await table.clear();
    }
  });

export { db };
